var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningF4HIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 76,
    viewBox: "0 0 83 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe03d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1ad04"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_7",
    x: 32.603,
    y: 18.015,
    width: 14.955,
    height: 50.707,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4331",
    "data-name": "Group 4331",
    transform: "translate(-639 -213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4324",
    "data-name": "Group 4324",
    transform: "translate(-138.111 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    transform: "translate(777.111 234)",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.70802307128906 69.64935302734375 L 10.29199028015137 69.64935302734375 C 8.493169784545898 69.64935302734375 6.878379821777344 68.72158050537109 5.972420215606689 67.16756439208984 C 5.066470146179199 65.61354827880859 5.054709911346436 63.75125122070312 5.940959930419922 62.18590927124023 L 35.64897918701172 9.714611053466797 C 36.54824066162109 8.126300811767578 38.17478942871094 7.178050994873047 40 7.178050994873047 C 41.82521057128906 7.178050994873047 43.45175933837891 8.126291275024414 44.35102844238281 9.714601516723633 L 74.05903625488281 62.1859016418457 C 74.94529724121094 63.75123977661133 74.93354034423828 65.61354827880859 74.02758026123047 67.16757202148438 C 73.12162017822266 68.72158050537109 71.50682830810547 69.64935302734375 69.70802307128906 69.64935302734375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 8.178047180175781 C 38.53983306884766 8.178047180175781 37.23859024047852 8.9366455078125 36.5191764831543 10.20729064941406 L 6.811164855957031 62.6785888671875 C 6.102157592773438 63.93085861206055 6.111564636230469 65.42070007324219 6.836334228515625 66.66390991210938 C 7.56109619140625 67.90712738037109 8.852935791015625 68.64934539794922 10.29197692871094 68.64934539794922 L 69.7080078125 68.64934539794922 C 71.14706420898438 68.64934539794922 72.43890380859375 67.90712738037109 73.16366577148438 66.66390991210938 C 73.88843536376953 65.42070007324219 73.89784240722656 63.93085861206055 73.18883514404297 62.6785888671875 L 43.4808235168457 10.20729064941406 C 42.76140975952148 8.9366455078125 41.46016693115234 8.178047180175781 40 8.178047180175781 M 40 6.178047180175781 C 42.03615951538086 6.178047180175781 44.07232284545898 7.192672729492188 45.22123336791992 9.221916198730469 L 74.92924499511719 61.69321441650391 C 77.19383239746094 65.69300079345703 74.30438995361328 70.64934539794922 69.7080078125 70.64934539794922 L 10.29197692871094 70.64934539794922 C 5.695610046386719 70.64934539794922 2.806167602539062 65.69300079345703 5.070755004882812 61.69321441650391 L 34.77876663208008 9.221916198730469 C 35.92767715454102 7.192672729492188 37.96384048461914 6.178047180175781 40 6.178047180175781 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 777.11, 234)",
    filter: "url(#Union_7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7-2",
    "data-name": "Union 7",
    d: "M0,39.735a3.977,3.977,0,1,1,7.955,0,3.977,3.977,0,0,1-7.955,0ZM1.023,30.8V2.99A2.959,2.959,0,0,1,3.972,0a2.994,2.994,0,0,1,3,2.99V30.8a2.994,2.994,0,0,1-3,2.99A2.959,2.959,0,0,1,1.023,30.8Z",
    transform: "translate(36.1 20.52)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(686 253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516",
    width: 36,
    height: 36,
    rx: 4,
    fill: "#251430"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(5.423 5.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M41.771,17.2v15.12a.522.522,0,0,1-.5.54H37.246a.479.479,0,0,1-.356-.155.554.554,0,0,1-.146-.382h0V22.6a.522.522,0,0,0-.5-.54H32.218a.522.522,0,0,0-.5.54v4.32a.522.522,0,0,1-.5.54H27.189a.522.522,0,0,1-.5-.54V22.6a.522.522,0,0,0-.5-.54H17.133a.522.522,0,0,1-.5-.54V17.2a.522.522,0,0,1,.5-.54H41.269a.522.522,0,0,1,.5.536Z",
    transform: "translate(-16.63 -16.66)",
    fill: "#00c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M41.773,57.97v4.32a.522.522,0,0,1-.5.54H17.133a.522.522,0,0,1-.5-.54V47.17a.522.522,0,0,1,.5-.54h4.023a.522.522,0,0,1,.5.54v9.72a.522.522,0,0,0,.5.54h4.023a.522.522,0,0,0,.5-.54V52.57a.522.522,0,0,1,.5-.54h4.023a.522.522,0,0,1,.5.54v4.32a.522.522,0,0,0,.5.54H41.27a.484.484,0,0,1,.361.145.558.558,0,0,1,.159.377Z",
    transform: "translate(-16.63 -38.649)",
    fill: "#00c8ff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningF4HIcon);
export default __webpack_public_path__ + "static/media/Warning_F4H_Icon.923bffc6f352f6c6fa16b1aaa2af6eb6.svg";
export { ForwardRef as ReactComponent };